import { render, staticRenderFns } from "./ClaimTypeQuestion.vue?vue&type=template&id=09252e0a&scoped=true"
import script from "./ClaimTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./ClaimTypeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09252e0a",
  null
  
)

export default component.exports